/** Shown when required VITE_* configuration is missing or invalid at startup. */
export function ConfigError({ problems }: { problems: string[] }) {
  return (
    <main style={{ maxWidth: 560, margin: '0 auto', padding: 'var(--space-12) var(--space-6)' }}>
      <h1 style={{ fontFamily: 'var(--font-display)' }}>TripCircle isn't configured yet.</h1>
      <p>The web app needs its environment settings before it can start:</p>
      <ul>
        {problems.map((problem) => (
          <li key={problem}>{problem}</li>
        ))}
      </ul>
    </main>
  );
}
